import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './SearchSources.module.scss';

export const SearchSources = () => {
  const { t } = useTranslation('news');

  return (
    <div className={styles.searchSourcesRoot} data-testid="search-sources">
      <h2 className={styles.title}>{t('news:searchSources')}</h2>

      <div className={styles.logotypes}>
        <img
          className={styles.img}
          src="/app/static/images/logotypes/wsj.svg"
          alt=""
        />
        <img
          className={styles.img}
          src="/app/static/images/logotypes/marketwatch.svg"
          alt=""
        />
        <img
          className={styles.img}
          src="/app/static/images/logotypes/barrons.svg"
          alt=""
        />
        <img
          className={styles.img}
          src="/app/static/images/logotypes/mtn.png"
          alt=""
        />
      </div>
    </div>
  );
};
